import { render, staticRenderFns } from "./BadgeText.vue?vue&type=template&id=c67fe874&"
import script from "./BadgeText.vue?vue&type=script&lang=ts&"
export * from "./BadgeText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports